import React from "react";
import { Globe } from "lucide-react";
import { US, SE } from "country-flag-icons/react/3x2";

/**
 * Locale flag (issue #140) — accurate bundled SVGs from `country-flag-icons`,
 * NOT emoji. Flag emoji fall back to the letters "US"/"SE" on Windows/Chrome
 * and read as an AI-slop "emoji-as-icon" tell; the library ships real,
 * tree-shakeable inline SVGs with no CDN dependency (works offline + SSG).
 *
 * Flags are decorative here — always paired with the locale's language label +
 * currency — so they carry `aria-hidden`. Unknown locales fall back to a
 * neutral globe (lucide-react) that inherits `currentColor` and themes.
 */

interface LocaleFlagProps {
	locale: string;
	className?: string;
}

// `country-flag-icons` doesn't export its FlagComponent type, so derive the
// map value type from one of the components (US/SE share the same signature).
const FLAG_BY_LOCALE: Record<string, typeof US> = {
	"en-US": US,
	"sv-SE": SE,
};

export const LocaleFlag: React.FC<LocaleFlagProps> = ({ locale, className }) => {
	const Flag = FLAG_BY_LOCALE[locale];
	const cls = className ?? "w-5 h-auto";
	if (Flag) {
		return <Flag className={cls} aria-hidden="true" focusable="false" />;
	}
	return <Globe className={cls} aria-hidden="true" focusable="false" />;
};

export default LocaleFlag;
